import React, { useMemo } from 'react'
import Typography from '@mui/material/Typography'
import { grey } from '../../../../colors'
import { Box } from '@mui/material'
import { TextListWrapper, ToolTipWrapper } from './styles'
import { InsightTooltip, type OverflowClickHandler } from '../OverflowIndicator'

interface TextListProps {
  list: string[]
  disabled?: boolean
  onOverflowClick?: OverflowClickHandler
}

const TextList: React.FC<TextListProps> = ({ list = [], disabled = false, onOverflowClick }) => {
  const sortedList = useMemo(() => [...list].sort((a, b) => a.localeCompare(b)), [list])

  const displayedValue = sortedList?.[0]
  const tooltipsValues = sortedList.slice(1)
  const overflowCount = Math.max(sortedList.length - 1, 0)

  const Title = (): JSX.Element => (
    <Box display="flex" gap={1} flexWrap="wrap">
      {tooltipsValues?.map((item, index) => (
        <Typography key={`${item}-${index}`} fontWeight={600} color={grey[0]} fontSize="12px">
          {item}
          {index !== tooltipsValues.length - 1 && ','}
        </Typography>
      ))}
    </Box>
  )

  return (
    <TextListWrapper color={grey[disabled ? 350 : 850]}>
      <Typography fontSize={'14px'}>
        {displayedValue}
      </Typography>
      {overflowCount > 0 && (
        <ToolTipWrapper onClick={onOverflowClick}>
          <InsightTooltip count={overflowCount} tooltipTitle={<Title />} onClick={onOverflowClick}>
            <Typography component="span" fontSize={14}>{`+${overflowCount}`}</Typography>
          </InsightTooltip>

        </ToolTipWrapper>
      )}
    </TextListWrapper>
  )
}

export default TextList
